<template>
  <div class="no-found">
    <v-container fluid>
      <v-row justify="center" class="title-maga">
        認定証自動発行システム
      </v-row>
      <v-row justify="center" class="title-404"> 403 </v-row>
      <v-row justify="center" class="title-error"> Error </v-row>
      <v-row justify="center" class="title-sorry mt-5">
        申し訳ございません。
      </v-row>
      <v-row justify="center" class="title-no-fond mt-5 mx-0 px-3">
        リクエスト内容を確認の上、再度アクセスしてください。</v-row
      >
      <v-row justify="center" class="pb-8 mb-16">
        <v-btn
          depressed
          large
          class="button-size btn-top err-btn-color"
          @click="goToTop"
        >
          トップページへ
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Forbidden",
  computed: {
    ...mapGetters(["userInfo"]),
    isAdmin() {
      return this.$route.path.startsWith("/admin");
    },
  },
  data: () => ({
    login_user: '',
  }),
  methods: {
    goToTop() {
      if (this.isAdmin) {
        this.login_user = JSON.parse(localStorage.getItem("adminUserInfo"));
      } else {
        this.login_user = JSON.parse(localStorage.getItem("userInfo"));
      }
      if (this.login_user) {
        if (this.isAdmin) {
          this.$router.push("/admin/users");
        } else {
          this.$router.push("/user/certificate");
        }
      } else {
        if (this.isAdmin) {
          this.$router.push("/admin/login");
        } else {
          this.$router.push("/login");
        }
      }
    }
  }
};
</script>
<style>
.row {
  margin-bottom: 0;
}
</style>